import { createAction, props } from '@ngrx/store';
import { ActionTypes } from './action-types';

import { Contact } from '../../../../models/contact';

export const getFirstContactForAccountAction = createAction(
  ActionTypes.GET_FIRST_CONTACT_FOR_ACCOUNT,
  props<{ payload: { accountId: string } }>()
);

export const getFirstContactForAccountSuccessAction = createAction(
  ActionTypes.GET_FIRST_CONTACT_FOR_ACCOUNT_SUCCESS,
  props<{ data: Contact | undefined }>()
);

export const getFirstContactForAccountFailureAction = createAction(
  ActionTypes.GET_FIRST_CONTACT_FOR_ACCOUNT_FAILURE,
  props<{ error: unknown }>()
);
